<img [@fade]="fade" src="assets/images/live_calls.svg" class="live_calls" alt="">
